export const EMAIL_CHANGED = 'email_changed';
export const PASSWORD_CHANGED = 'password_changed';

export const ADD_MENU = 'add_menu';
export const GET_MENU_LIST = 'get_menu_list';
export const REMOVE_MENU = 'remove_menu';
export const MENU_NAME_CHANGE = 'menu_name_change';
export const CHANGE_MENU = 'change_menu';

export const ADD_PRODUCT = 'add_product';
export const GET_PRODUCT_LIST = 'get_product_list';

export const ADD_ROOM = 'add_room';
export const GET_ROOM_LIST = 'get_room_list';

export const ADD_TABLE = 'add_table';
export const GET_TABLE_LIST = 'get_table_list';

export const SELECT_MENU = 'select_menu';
export const SELECT_ROOM = 'select_room';